import { useSharedSound } from "./useSharedSound";
import clickSound from "@/assets/sounds/click.mp3";

/**
 * Centralized click sound hook that provides a consistent click sound
 * across all interactive components.
 *
 * @param options Optional configuration for the click sound
 * @returns A play function to trigger the click sound
 */
export function useClickSound(options: { volume?: number; debug?: boolean } = {}) {
  const { volume = 0.6, debug = false } = options;

  const [play] = useSharedSound(clickSound, { volume, debug });

  return play;
}

export default useClickSound;
